var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    'wgt-search': true,
    'padded': _vm.value.padded
  }},[(_vm.value.title || _vm.value.subtitle)?_c('div',{staticClass:"wgt-hd"},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.value.title))]),_c('span',{staticClass:"sub-title"},[_vm._v(_vm._s(_vm.value.subtitle))])]):_vm._e(),_c('div',{staticClass:"wgt-bd",class:{
      'spaced': _vm.value.spaced
    }},[_c('div',{staticClass:"search-container"},[_c('i',{staticClass:"ecx-icon icon-sousuo"}),_c('span',{staticClass:"placeholder"},[_vm._v(" "+_vm._s(_vm.value.placeholder)+" ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }